var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 60,
    viewBox: "0 0 231 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1859_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.231445V59.2314H54.978V52.6249H6.5604V6.83798H54.978V0.231445H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6172 26.5661L103.857 12.1602H111.526L100.531 29.227V30.1446L112.081 47.3032H104.134L94.6172 32.8973V26.5661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.074 32.8973H142.852L138.879 15.4634H137.955L133.982 32.8973H134.074ZM144.331 39.5039H132.596L130.84 47.3032H123.91L132.226 12.1602H144.608L152.924 47.3032H145.994L144.238 39.5039H144.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.477 12.1602H177.037V40.972H192.93V47.3032H170.477V12.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4286 22.8955C60.4286 21.5192 59.8742 20.2346 58.7654 19.2252C57.6566 18.2159 56.1782 17.6654 54.1454 17.6654C52.4822 17.6654 51.1886 18.0324 50.1722 18.6747C49.1558 19.4088 48.6938 20.3263 48.6938 21.4274C48.6938 22.0697 48.7862 22.6203 49.0634 23.079C49.3406 23.5378 49.7102 23.9966 50.2646 24.3637C50.819 24.7307 51.5582 25.0977 52.5746 25.373C53.4986 25.6483 54.6998 25.9235 56.1782 26.1988C59.8742 26.8411 62.6462 28.0339 64.5866 29.5938C66.527 31.1537 67.5434 33.4476 67.5434 36.5674V37.2097C67.5434 38.8613 67.2662 40.3294 66.6194 41.614C66.065 42.8986 65.2334 44.0915 64.1246 45.0091C63.0158 45.9266 61.7222 46.6607 60.1514 47.2112C58.5806 47.67 56.825 47.9453 54.8846 47.9453C52.5746 47.9453 50.5418 47.5783 48.7862 46.936C47.0306 46.2937 45.5522 45.3761 44.4434 44.1832C43.3346 42.9904 42.4106 41.7058 41.7638 40.1459C41.117 38.586 40.8398 36.8427 40.8398 35.0993V34.824H47.4002C47.4002 36.9344 48.047 38.586 49.2482 39.8706C50.4494 41.1553 52.2974 41.7976 54.8846 41.7976C56.9174 41.7976 58.3958 41.3388 59.3198 40.513C60.3362 39.5954 60.7982 38.586 60.7982 37.3932C60.7982 36.8427 60.7058 36.2921 60.521 35.7416C60.3362 35.191 59.9666 34.7322 59.5046 34.3652C59.0426 33.9064 58.3034 33.5394 57.4718 33.2641C56.5478 32.8971 55.5314 32.6218 54.1454 32.4383C52.3898 32.163 50.819 31.7042 49.2482 31.2455C47.7698 30.7867 46.4762 30.1444 45.4598 29.3186C44.351 28.4927 43.5194 27.4834 42.965 26.2906C42.3182 25.0977 42.041 23.6296 42.041 21.8862V21.6109C42.041 20.1428 42.3182 18.8582 42.965 17.6654C43.5194 16.4725 44.351 15.3714 45.4598 14.4539C46.4762 13.5363 47.7698 12.8022 49.2482 12.3434C50.7266 11.8846 52.3898 11.6094 54.2378 11.6094C56.2706 11.6094 58.1186 11.8846 59.6894 12.5269C61.2602 13.0775 62.6462 13.9033 63.755 14.9126C64.8638 15.922 65.603 17.1148 66.2498 18.3994C67.0814 19.9593 67.0814 23.079 67.0814 23.079L60.521 22.9873L60.4286 22.8955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27 12.1602V47.3032H231V40.972H214.922V18.4914H231V12.1602H208.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9042 12.1602H83.3438V47.3032H89.9042V12.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.92 26.5654H219.637V32.8967H225.92V26.5654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1859_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 59,
    fill: "white",
    transform: "translate(0 0.231445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkale);
export default __webpack_public_path__ + "static/media/skale.00bf1f326a15422cd6c79b602535a5d7.svg";
export { ForwardRef as ReactComponent };